/**
 * Sorts an array of objects based on a specified column and sort direction
 * @param {Array} data - The array of objects to sort
 * @param {string} sortBy - The column name to sort by
 * @param {string} sortOrder - The sort direction ('asc' or 'desc')
 * @returns {Array} The sorted array
 */
export const sortData = (data, sortBy, sortOrder) => {
    if (!sortBy || !sortOrder) return data;
    
    return [...data].sort((a, b) => {
        const aVal = a[sortBy] || '';
        const bVal = b[sortBy] || '';
        if (sortOrder === 'asc') {
            return aVal.toString().localeCompare(bVal.toString());
        } else {
            return bVal.toString().localeCompare(aVal.toString());
        }
    });
};

/**
 * Handles sort state changes from FilterIcon component
 * @param {string} columnId - The column being sorted
 * @param {string} sortDirection - The new sort direction
 * @param {string} currentSortBy - Current sort column
 * @param {string} currentSortOrder - Current sort direction
 * @returns {Object} New sort state {sortBy, sortOrder}
 */
export const handleSortChange = (columnId, sortDirection, currentSortBy, currentSortOrder) => {
    if (sortDirection) {
        return {
            sortBy: columnId,
            sortOrder: sortDirection
        };
    } else if (currentSortBy === columnId) {
        return {
            sortBy: null,
            sortOrder: null
        };
    }
    return {
        sortBy: currentSortBy,
        sortOrder: currentSortOrder
    };
}; 